module.exports = __webpack_public_path__ + "img/ps.942cf790.png";